"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgEyeOpenIcon = function SvgEyeOpenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6 18.404c-3.125-.655-5.827-3.054-7.382-5.38 1.151-1.776 2.823-3.472 4.78-4.54a5.093 5.093 0 1 0 8.088-.108c1.602.873 3.24 2.356 4.846 4.65-1.743 2.45-3.518 3.944-5.228 4.755-1.769.838-3.497.96-5.105.623Zm11.354-5.658C18.261 7.31 14.193 5.805 10.54 6.5c-3.588.683-6.613 3.463-8.34 6.265l-.165.266.167.264c1.615 2.55 4.603 5.335 8.193 6.088 1.808.379 3.76.24 5.739-.698 1.972-.935 3.942-2.65 5.82-5.374l.194-.281-.193-.284Zm-5.779-1.221a4.093 4.093 0 1 1-8.185 0 4.093 4.093 0 0 1 8.185 0Z",
    fill: "#4D4D4D"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgEyeOpenIcon);
var _default = exports["default"] = Memo;